//
//
//
//
//
//

export default {
  props: ['title']
}



// WEBPACK FOOTER //
// ./src/components/HeaderBar/HeaderBar.vue